import React from 'react'
import { Button } from 'antd'
import { TEXT_BUTTON } from 'config'

export default ({ onClick, text = TEXT_BUTTON.CANCEL }) => (
  <Button type="cancel" onClick={onClick}>
    {text}
  </Button>
)
